module.exports = __webpack_public_path__ + "img/202409091229015898xy.f8cf6498.jpg";